/**
 * @file complianceConstants.js
 * @description Constants for the Compliance module within the Admin section.
 *              Includes UI label strings, table column definitions, column key mappings,
 *              data field key mappings, and user-facing messages.
 *
 * @module complianceConstants
 *
 * @exports COMPLIANCE_STRINGS        - UI label strings (e.g. "Rule Description", "Edit Rule").
 * @exports COMPLIANCE_TABLE_COLUMNS  - Column config array for the compliance rules table.
 * @exports COMPLIANCE_TABLE_COLUMN_KEYS - Enum-style keys matching table column IDs.
 * @exports COMPLIANCE_KEYS           - Enum-style keys for compliance data fields.
 * @exports COMPLIANCE_MESSAGES       - User-facing message strings (e.g. empty-state text).
 */
export const COMPLIANCE_STRINGS = {
    RULE_DESCRIPTION: "Rule Description",
    EDIT_RULE: "Edit Rule",
    VALUE: "Value",
};

export const COMPLIANCE_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "ruleid", isSortable: false, label: "Rule ID" },
    { id: "description", isSortable: false, label: "Description" },
    { id: "value", isSortable: false, label: "Value" },
    { id: "isenabled", isSortable: false, label: "Is Enabled" },
];

export const COMPLIANCE_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    RULEID: "ruleid",
    DESCRIPTION: "description",
    VALUE: "value",
    ISENABLED: "isenabled"
};

export const COMPLIANCE_KEYS = {
    RULEID: "ruleid",
    DESCRIPTION: "description",
    VALUE: "value",
    ISENABLED: "isenabled",
};

export const COMPLIANCE_MESSAGES = {
    NO_RULES: "No Rules to display",
};